import React from 'react';

type HeroSectionProps = {
  backgroundImage: string;
  headingText: string;
  subHeadingText?: string;
  heightSize?: "small" | "medium" | "large";
  profileImage?: string | null;
};

const heightMap = {
  small: "min-h-[50vh]",
  medium: "min-h-[65vh]",
  large: "min-h-[80vh]",
};

const HeroSection: React.FC<HeroSectionProps> = ({
  backgroundImage,
  headingText,
  subHeadingText = "",
  profileImage = null,
  heightSize = "medium",
}) => {
  return (
    <section
      className={`relative w-full bg-cover bg-center ${heightMap[heightSize]}`}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center text-center space-y-4 px-4">
        {profileImage && (
          <img
            src={profileImage}
            alt="Profile"
            className="rounded-full w-48 h-48 object-cover"
          />
        )}

        <h1 className="text-page text-4xl md:text-6xl font-bold">
          {headingText}
        </h1>

        {subHeadingText && (
          <h2 className="text-page text-xl md:text-3xl font-semibold max-w-3xl">
            {subHeadingText}
          </h2>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
